"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = function _default(_ref) {
  var isOpen = _ref.isOpen,
    setOpen = _ref.setOpen,
    _ref$wrapperClassName = _ref.wrapperClassName,
    wrapperClassName = _ref$wrapperClassName === void 0 ? 'btn-group' : _ref$wrapperClassName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setOpen(true);
    },
    className: 'btn ' + (isOpen ? 'disabled btn-success' : 'btn-default')
  }, "OPEN"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setOpen(false);
    },
    className: 'btn ' + (isOpen ? 'btn-default' : 'disabled btn-danger')
  }, "CLOSED"));
};
exports["default"] = _default;